import { MessageCircle, Mail, Calendar, Phone } from "lucide-react";
import { useTranslation } from "react-i18next";
import { BRAND } from "@/lib/data";
import { FLOATING } from "@/constants/testIds";

export default function FloatingActions() {
  const { t } = useTranslation();
  return (
    <>
      {/* Desktop: slim vertical bar on right */}
      <div
        data-testid={FLOATING.bar}
        className="pointer-events-auto fixed right-6 top-1/2 z-40 hidden -translate-y-1/2 flex-col items-center gap-3 lg:flex"
      >
        <a
          href={BRAND.phoneHref}
          aria-label="Call"
          className="group relative flex h-11 w-11 items-center justify-center rounded-full border border-ivory/10 bg-ink-800/80 backdrop-blur text-ivory transition-colors hover:border-gold hover:text-gold"
        >
          <Phone size={16} />
        </a>
        <a
          data-testid={FLOATING.whatsapp}
          href={BRAND.whatsappHref}
          target="_blank"
          rel="noreferrer noopener"
          aria-label="WhatsApp"
          className="group relative flex h-11 w-11 items-center justify-center rounded-full border border-ivory/10 bg-ink-800/80 backdrop-blur text-ivory transition-colors hover:border-gold hover:text-gold"
        >
          <MessageCircle size={16} />
        </a>
        <a
          data-testid={FLOATING.email}
          href={`mailto:${BRAND.email}`}
          aria-label="Email"
          className="group relative flex h-11 w-11 items-center justify-center rounded-full border border-ivory/10 bg-ink-800/80 backdrop-blur text-ivory transition-colors hover:border-gold hover:text-gold"
        >
          <Mail size={16} />
        </a>
        <a
          data-testid={FLOATING.meeting}
          href={BRAND.meetingHref}
          aria-label="Book a meeting"
          className="group relative flex h-11 w-11 items-center justify-center rounded-full border border-gold/40 bg-gold text-ink-950 transition-colors hover:bg-transparent hover:text-gold"
        >
          <Calendar size={16} />
        </a>
      </div>

      {/* Mobile: hidden. The Eyes mascot handles primary contact intent */}
      <div className="pointer-events-auto fixed inset-x-4 bottom-4 z-40 hidden items-stretch justify-between gap-1 rounded-full border border-ivory/10 bg-ink-800/85 p-1 backdrop-blur">
        <a
          href={BRAND.phoneHref}
          className="flex flex-1 items-center justify-center gap-2 rounded-full px-2 py-3 text-[10px] uppercase tracking-widest text-ivory hover:text-gold"
        >
          <Phone size={13} /> {t("nav.call")}
        </a>
        <a
          href={BRAND.whatsappHref}
          target="_blank"
          rel="noreferrer noopener"
          className="flex flex-1 items-center justify-center gap-2 rounded-full px-2 py-3 text-[10px] uppercase tracking-widest text-ivory hover:text-gold"
        >
          <MessageCircle size={13} /> {t("nav.whatsapp")}
        </a>
        <a
          href={`mailto:${BRAND.email}`}
          className="flex flex-1 items-center justify-center gap-2 rounded-full px-2 py-3 text-[10px] uppercase tracking-widest text-ivory hover:text-gold"
        >
          <Mail size={13} /> {t("nav.email")}
        </a>
        <a
          href={BRAND.meetingHref}
          className="flex flex-1 items-center justify-center gap-2 rounded-full bg-gold px-2 py-3 text-[10px] uppercase tracking-widest text-ink-950"
        >
          <Calendar size={13} /> {t("nav.bookMeeting").split(" ")[0]}
        </a>
      </div>
    </>
  );
}
